import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})


export class ClientAdminService {
  private _clientAdmin = `${environment.administration}/users`;
  private _userRoles = `${environment.common}/GetRolePermissions`
  constructor(
    private _http: HttpClient
  ) { }

  // Add user details service
  addUserDetails(formData: any) {
    return this._http.post<any>(`${this._clientAdmin}/adduser`, formData);
  }

  // Get all Userslist
  getAllUsers(pageNo: number, pageSize: number, searchKeyword: string, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this._clientAdmin}`, paginationSettings);
  }

  // Get particular User details
  getUser(id: any) {
    return this._http.get<any>(`${this._clientAdmin}/user/${id}`);
  }

  // update user
  updateUser(id: any, formData: any) {
    return this._http.put<any>(`${this._clientAdmin}/user/${id}`, formData);
  }

  // upload user image
  uploadUserImage(formData: any) {
    return this._http.post<any>(`${this._clientAdmin}/user/uploadimage`, formData);
  }

  // delete user
  deleteUser(id: any) {
    return this._http.delete<any>(`${this._clientAdmin}/user/${id}`);
  }

  requestSenderEmailAccess(email: any) {
    return this._http.put<any>(`${environment.administration}/RequestSenderEmailIdentity/${email}`, "");
  }

  forgotPassword(email: any): Observable<any> {
    return this._http.post<any>(`${environment.integration}/forgotpassword/${email}`, {});
  }

  performBulkActions(req: any): Observable<any> {
    return this._http.put<any>(`${environment.administration}/updateusers`, req)
  }
  // Invoice & Payment details 
  invoicePaymentDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${environment.administration}/paymentdetails`, formData);
  }
  editInvoicePaymentDetails(formData: any): Observable<any> {
    return this._http.put<any>(`${environment.administration}/paymentdetails`, formData);
  }
  getInvoicePaymentDetails(): Observable<any> {
    return this._http.get<any>(`${environment.administration}/paymentdetails`);
  }

  getTripmeldAdminUsers(): Observable<any> {
    return this._http.get<any>(`${environment.administration}/users/TMAdminUsers`);
  }
}



